import React, { useState } from 'react';
import { App } from 'antd';
import DebounceSelect from 'components/Select/DebounceSelect';
import { captureException } from 'utils/errors';
import http from 'utils/http';

function ContactSelectInput({
  value,
  onChange,
  placeholder = 'Select contact...',
  disabled = false,
  style = {},
  companyId, // Optional: if provided, fetch contacts for specific company
  ...props
}) {
  const [loading, setLoading] = useState(false);
  const { message } = App.useApp();

  const fetchContactOptions = async (search) => {
    setLoading(true);
    try {
      // If companyId is provided, fetch company-specific contacts
      // Otherwise fetch all contacts
      const endpoint = companyId
        ? `v1/organizations/{{organizationId}}/companies/${companyId}/contacts/`
        : 'v1/organizations/{{organizationId}}/contacts/';

      const params = {
        search,
        page_size: 50, // Limit results for performance
      };

      const res = await http.get(endpoint, { params });

      // Handle different response structures
      const contacts = res.data?.results || res.data?.data?.results || [];

      return contacts.map((contact) => ({
        value: contact.id,
        label: `${contact.first_name || ''} ${contact.last_name || ''}`.trim() || contact.email,
        email: contact.email,
        phone: contact.phone,
        role: contact.role,
        // Store full contact data for potential use
        contact,
      }));
    } catch (e) {
      captureException(e);
      message.error('Failed to fetch contacts');
      return [];
    } finally {
      setLoading(false);
    }
  };

  return (
    <DebounceSelect
      style={{ width: '100%', ...style }}
      value={value}
      fetchOptions={fetchContactOptions}
      onChange={onChange}
      placeholder={placeholder}
      allowClear
      disabled={disabled}
      loading={loading}
      showSearch
      filterOption={false}
      optionRender={(option) => (
        <div>
          <div className="font-medium">{option.label}</div>
          {option.data?.email && (
            <div className="text-xs text-gray-500">{option.data.email}</div>
          )}
          {option.data?.role && (
            <div className="text-xs text-gray-400">{option.data.role}</div>
          )}
        </div>
      )}
      {...props}
    />
  );
}

export default ContactSelectInput;
